<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "../components/loader"
import Basic from "./basic";
import NaoAtendidos from "./naoatendidos";
import api from "@/axios";
import {getBaseUrl} from "@/helpers/baseUrl";

/**
 * Leaflet-map component
 */
export default {
  page: {
    title: "Mapas",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader,
    Basic,
    NaoAtendidos,
    Loader
  },
  data() {
    return {
      loadingList: true,
      pessoasList: null,
      title: "Mapas",
      items: [
        {
          text: "Clientes",
          href: "clientes/list"
        },
        {
          text: "Mapas",
          active: true
        }
      ]
    };
  },
  mounted() {

    api.get(`${getBaseUrl()}api/clilats`).then((res) => {
      console.log('then axios')
      console.log(res.data[0])
      this.pessoasList = res.data[0]

      // this.title = `(${this.markersList.length}) Clientes / Fornecedores`
      this.loadingList = false
      // this.markersList.forEach((value) => {
      //     if (value.latlong){
      //       console.log('latlong')
      //       console.log(value.latlong)
      //       //
      //       // const latLong = value.latlong
      //       // const posVirg = latLong.indexOf(",");
      //       // const lat =  parseFloat(latLong.substring(0, posVirg))
      //       // const long = parseFloat(latLong.substring(posVirg + 2, latLong.length))
      //
      //
      //
      //       // this.markers = [
      //       //   {
      //       //     position: { lat: lat, lng: long },
      //       //   },
      //       // ]
      //       //
      //       // this.markerOptions = {
      //       //   position: { lat: lat, lng: long },
      //       //   label: "01",
      //       //   title: "LADY LIBERTY"
      //       // }
      //
      //
      //     }
      //   })
    })

  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="loadingList" style="min-height: 300px;">
    </Loader>

    <div class="row" v-if="pessoasList">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Todos os Clientes</h4>
            <Basic class="leaflet-map" :pessoasList="pessoasList"/>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Não Cadastrados (Dados Públicos)</h4>
            <NaoAtendidos class="leaflet-map" :pessoasList="pessoasList"/>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="pessoasList">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Pedidos</h4>
            <Basic class="leaflet-map" :pessoasList="pessoasList"/>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Orçamentos</h4>
            <NaoAtendidos class="leaflet-map" :pessoasList="pessoasList"/>
          </div>
        </div>
      </div>
    </div>


  </Layout>
</template>